import {
	ADD_SAMPLE_ATTRIBUTES_STATUS,
	CLEAR_SAMPLE_ATTRIBUTES,
	CREATE_CONTROL_ATTRIBUTES,
	CREATE_SAMPLE,
	DELETE_ATTRIBUTE_FROM_SAMPLE_ITEM,
	DELETE_CONTROL_ATTRIBUTES,
	DELETE_SAMPLE_ITEM,
	EDIT_SAMPLE_ITEM,
	GET_SAMPLEITEMS_BY_ID,
	GET_SAMPLE_ITEMS,
	RELATE_TAG_SAMPLE_ITEM,
	UNRELATE_TAG_SAMPLE_ITEM,
	UPDATE_SAMPLE_ATTRIBUTES_STATUS,
	EDIT_SAMPLE_TAG
} from '../../actions/actiontypes';
import {isApiResponseOk, normalize, normalizedDelete} from '../../util/utils';

import initialstate from '../initialstate';

export default function sampleItemReducer(state = initialstate.sampleItems, action) {
	switch (action.type) {
		case GET_SAMPLEITEMS_BY_ID:
			if (isApiResponseOk(action) && action.response.sampleItem) {
				let sampleItem = state.byId[action.response.sampleItem?.sampleItemId];
				sampleItem = {
					...action.response.sampleItem,
					id: action.response.sampleItem?.sampleItemId,
					relatedAttributes: action.response.relatedAttributes,
					relatedSampleItemTags: action.response.sampleItem?.relatedSampleItemTags
				};
				return normalize([sampleItem], undefined, state);
			} else return state;

		case CREATE_SAMPLE:
			if (action.response) {
				state = {...state, relatedSampleItemTags: []};
				return normalize([action.response], undefined, state);
			}
			return state;

		case GET_SAMPLE_ITEMS:
			if (isApiResponseOk(action)) {
				if (action.response.data) {
					let sampleListItems = normalize(action.response.data.sampleItems, 'sampleItemId', state, undefined, true);
					sampleListItems.page = action.response.page;
					sampleListItems.pages = action.response.pages;
					sampleListItems.totalEntityCount = action.response.totalEntityCount;
					sampleListItems.attributesCount = action.response.data?.relatedAttributes?.length;
					sampleListItems.relatedAttributes = action.response.data?.relatedAttributes;
					sampleListItems.relatedSampleItemTags = action.response.data?.sampleItems?.relatedSampleItemTags;
					return sampleListItems;
				}
				return state;
			} else return state;
		case EDIT_SAMPLE_ITEM:
			if (isApiResponseOk(action)) {
				let updatedSampleItem = state.byId[action.response.id];
				updatedSampleItem = {
					...updatedSampleItem,
					sampleItemName: action.response.sampleItemName,
					sampleItemDate: action.response.sampleItemDate
				};

				return normalize([updatedSampleItem], undefined, state);
			} else return state;

		case DELETE_SAMPLE_ITEM:
			if (isApiResponseOk(action)) {
				return normalizedDelete(state, action.sampleItemId);
			} else return state;

		case CLEAR_SAMPLE_ATTRIBUTES:
			Object.keys(state.byId).forEach((id) => {
				let sampleItem = {...state.byId[id]};
				delete sampleItem.sampleItem?.relatedItemAttributes;
			});
			return state;
		case ADD_SAMPLE_ATTRIBUTES_STATUS:
			if (isApiResponseOk(action)) {
				let updatedSampleItem = JSON.parse(JSON.stringify(state.byId[action.response.sampleItemId]));
				let rItemAttribute = {
					attributeStatusId: action.response?.attributeStatusId,
					rationale: action.response?.rationale,
					attributeId: action.response?.attributeId
				};
				updatedSampleItem = {
					...updatedSampleItem,
					relatedItemAttributes: [...updatedSampleItem.relatedItemAttributes, rItemAttribute]
				};
				return {
					...state,
					byId: {
						...state.byId,
						[action.response.sampleItemId]: updatedSampleItem
					}
				};
			} else return state;
		case UPDATE_SAMPLE_ATTRIBUTES_STATUS:
			if (isApiResponseOk(action)) {
				let updatedSampleItem = JSON.parse(JSON.stringify(state.byId[action.response.sampleItemId]));
				let rItemAttribute = {
					...updatedSampleItem,
					relatedItemAttributes: updatedSampleItem.relatedItemAttributes.map((item) => {
						if (item.attributeId === action.response.attributeId) {
							return {
								...item,
								attributeStatusId: action.response.attributeStatusId,
								rationale: action.response.rationale
							};
						} else return item;
					})
				};
				return {
					...state,
					byId: {
						...state.byId,
						[action.response.sampleItemId]: rItemAttribute
					}
				};
			} else return state;

		case DELETE_ATTRIBUTE_FROM_SAMPLE_ITEM:
			let updatedSampleItem = JSON.parse(JSON.stringify(state.byId[action.sampleItemId]));
			updatedSampleItem.relatedItemAttributes = updatedSampleItem.relatedItemAttributes.filter(
				(item) => item.attributeId !== action.attributeId
			);
			return {
				...state,
				byId: {
					...state.byId,
					[action.sampleItemId]: updatedSampleItem
				}
			};
		case RELATE_TAG_SAMPLE_ITEM:
			if (isApiResponseOk(action)) {
				let updatedSampleItem = JSON.parse(JSON.stringify(state.byId[action?.sampleItemId]));
				let relatedSampleItemTags = {
					engagementId: action?.engagementId,
					engagementTagId: action?.tagDetails?.engagementTagId,
					engagementTagName: action?.tagDetails?.engagementTagName,
					colorCode: action?.tagDetails?.colorCode,
					sampleItemId: action?.sampleItemId
				};
				updatedSampleItem = {
					...updatedSampleItem,
					relatedSampleItemTags: [...updatedSampleItem.relatedSampleItemTags, relatedSampleItemTags]
				};
				return {
					...state,
					byId: {
						...state.byId,
						[action.sampleItemId]: updatedSampleItem
					}
				};
			} else return state;
		case UNRELATE_TAG_SAMPLE_ITEM:
			if (isApiResponseOk(action)) {
				let updatedSampleItem = JSON.parse(JSON.stringify(state.byId[action?.sampleItemId]));
				let UnrelatedSampleItemTags = {
					engagementTagId: action?.tagId
				};
				updatedSampleItem = {
					...updatedSampleItem,
					relatedSampleItemTags: updatedSampleItem.relatedSampleItemTags.filter(
						(item) => item.engagementTagId !== UnrelatedSampleItemTags.engagementTagId
					)
				};
				return {
					...state,
					byId: {
						...state.byId,
						[action.sampleItemId]: updatedSampleItem
					}
				};
			} else return state;
		case EDIT_SAMPLE_TAG:
			if (isApiResponseOk(action)) {
				let updatedSampleItem = state.byId[action.sampleItemId];
				updatedSampleItem = {
					...updatedSampleItem,
					relatedSampleItemTags: updatedSampleItem.relatedSampleItemTags.map((item) => {
						if (item.engagementTagId === action.response.tagId) {
							return {
								...item,
								engagementTagName: action.response.name,
								colorCode: action.response.colorCode
							};
						} else return item;
					})
				};

				return normalize([updatedSampleItem], undefined, state);
			} else return state;
		case CREATE_CONTROL_ATTRIBUTES: {
			if (isApiResponseOk(action) && state.relatedAttributes?.length) {
				const {id, entityId, entityUIDINT, sampleTypeId, attributeIndex, attributeDescription} = action.response;
				const sampleListId = state.relatedAttributes[0]?.sampleListId || 0;
				const updatedRelatedAttributes = [
					...state.relatedAttributes,
					{
						attributeId: id,
						entityID: entityId,
						entityUIDINT,
						sampleTypeId,
						attributeIndex,
						attributeDescription,
						sampleListId
					}
				];

				return {...state, attributesCount: state.attributesCount + 1, relatedAttributes: updatedRelatedAttributes};
			}
			return state;
		}
		case DELETE_CONTROL_ATTRIBUTES: {
			if (isApiResponseOk(action) && state.relatedAttributes?.length) {
				const {attributeId} = action;

				// Check if any relatedItemAttributes match the attributeId
				const updatedById = Object.keys(state.byId).reduce((acc, key) => {
					const item = state.byId[key];
					const updatedRelatedItemAttributes = item.relatedItemAttributes.filter(
						(attr) => attr.attributeId !== attributeId
					);

					acc[key] = {
						...item,
						relatedItemAttributes: updatedRelatedItemAttributes
					};

					return acc;
				}, {});

				const updatedRelatedAttributes = state.relatedAttributes.filter(
					(attribute) => attribute.attributeId !== attributeId
				);

				return {
					...state,
					byId: updatedById,
					relatedAttributes: updatedRelatedAttributes,
					attributesCount: state.attributesCount - 1
				};
			}
			return state;
		}
		default:
			return state;
	}
}
